<template>
  <v-row justify="center">
    <v-col cols="12" class="pt-16">
      <v-container>
        <back-button @click.native="$router.go(-1)"></back-button>
        <v-row>
          <v-col cols="12" lg="6">
            <h3 class="mb-8 home-header-3">
              Which of the following apply to you?
            </h3>
            <div
              v-for="meningitisBItem in meningitisBItems"
              :key="meningitisBItem.value"
            >
              <v-checkbox
                v-model="meningitisB"
                v-on:change="onCheckboxChange(meningitisBItem.value)"
                v-on:keyup.native.enter="
                  addRemoveMeningitisB(meningitisBItem.value)
                "
                :label="meningitisBItem.label"
                :value="meningitisBItem.value"
                color="#006078"
                class="ml-4 black--text"
                :ripple="false"
              ></v-checkbox>
            </div>
            <v-btn 
              @click="onAfterContinueClicked"
              class="mt-8 v-btn--primary"
              :disabled="!meningitisB.length">
              Continue
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import BackButton from '@/components/BackButton';
import meningitisBItems from '@/data/meningitis-b';

export default Vue.extend({
  components: {
    BackButton
  },
  name: 'StepMeningitisB2',
  data: () => ({
    meningitisBItems: meningitisBItems,
    meningitisB: []
  }),
  mounted: function() {
    this.$store.commit('setMeningitisBDose', null);
  },
  computed: {
    ...mapGetters([
      'getDateOfBirth'
    ]),
    isEligibleBasedOnSelectionsAndDOB() {
      // If any of the first options (not "None of the above") are selected, eligible
      const anyOtherSelected = this.meningitisB.some(item => item !== 'None of the above');
      if (anyOtherSelected) {
        return true;
      }

      // Only "None of the above" is selected, check DOB range
      const noneOfAboveSelected = this.meningitisB.includes('None of the above');
      if (noneOfAboveSelected) {
        const raw = new Date(this.getDateOfBirth);
        const dob = new Date(raw.getFullYear(), raw.getMonth(), raw.getDate());
        const minDate = new Date(2007, 6, 2);   // 02/07/2007
        const maxDate = new Date(2008, 6, 1);   // 01/07/2008
        
        return dob >= minDate && dob <= maxDate;
      }
      
      return false;
    },
  },
  methods: {
    addRemoveMeningitisB(value) {
      const index = this.meningitisB.indexOf(value);
      if (index > -1) {
        this.meningitisB.splice(index, 1);
      } else {
        this.meningitisB.push(value);
      }
    },
    onCheckboxChange(changedValue) {
      if (changedValue === 'None of the above') {
        // "None of the above" selected — deselect everything else
        this.meningitisB = this.meningitisB.includes('None of the above')
          ? ['None of the above']
          : [];
      } else {
        // Any other option selected — deselect "None of the above"
        this.meningitisB = this.meningitisB.filter(item => item !== 'None of the above');
      }
      this.saveMeningitisB();
    },
    saveMeningitisB() {
      this.$store.commit('setMeningitisBDose', null);
      this.$store.commit('setIsEligibleForMeningitisBVaccine', null);
    },
    onAfterContinueClicked() {
      this.$gtag.event('MeningitisB eligibility screen answered', {})

      this.$store.commit('setIsEligibleForMeningitisBVaccine', this.isEligibleBasedOnSelectionsAndDOB)

      if (this.isEligibleBasedOnSelectionsAndDOB) {
        this.$router.push('/booking/meningitis-b-3').catch(() => {});
      } else {
        this.$router.push('/booking/meningitis-b-not-eligible-age').catch(() => {});
      }
    }
  }
});
</script>
